import { Form, notification } from 'antd';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Redirect } from 'react-router-dom';

import { withFeatureFlag } from '@/components/FeatureFlag/FeatureFlag';
import { LoginCard, LoginFormItem, LoginSubmit } from '@/components/Login';
import PasswordRequirements from '@/components/PasswordRequirements';
import {
  createPasswordOnChangeHandler,
  getPasswordConfirmationRules,
  getPasswordRules,
} from '@/components/PasswordRequirements/passwordValidation';
import Session from '@/services/Session';
import { updateExpiredPassword } from '@/services/api';

import OldNewPassword from './deprecated/OldNewPassword';

class NewPassword extends Component {
  static propTypes = {
    location: PropTypes.shape({
      state: PropTypes.shape({
        username: PropTypes.string,
      }),
    }).isRequired,
  };

  state = {
    redirectTo: undefined,
    loading: false,
  };

  handleSuccess = () => {
    this.setState({
      redirectTo: '/user/login',
      loading: false,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    const { form } = this.props;

    if (this.state.loading) {
      return;
    }

    form.validateFieldsAndScroll(async (err, values) => {
      if (err) {
        this.setState({
          loading: false,
        });
        return;
      }
      this.setState({
        loading: true,
      });

      try {
        await updateExpiredPassword(
          Session.challenge(),
          {
            ...values,
            username: this.props.location.state.username,
          },
          this.props.authenticityToken,
        );
        this.handleSuccess();
      } catch (error) {
        const { response } = error;
        const { form } = this.props;

        // Display field-specific errors
        const hasFieldErrors = response?.errors?.some((res) => res.id);
        if (response?.errors) {
          response.errors.forEach((res) => {
            if (res.id) {
              form.setFields({
                [res.id]: {
                  value: values[res.id] || form.getFieldValue(res.id),
                  errors: [new Error(res.detail)],
                },
              });
            }
          });
        }

        // Don't show notification for field-specific validation errors
        const generalError =
          response?.errors?.find((res) => !res.id)?.detail ||
          (!hasFieldErrors && (response?.error || error.message));

        if (generalError) {
          notification.error({ message: 'Error', description: String(generalError) });
        }

        this.setState({ loading: false });
      }
    });
  };

  renderFormItems = () => {
    const {
      form: { getFieldDecorator, getFieldValue },
      form,
    } = this.props;

    const passwordRules = getPasswordRules();
    const passwordConfirmationRules = getPasswordConfirmationRules(getFieldValue);
    const passwordOnChange = createPasswordOnChangeHandler(form, 'password_confirmation');

    const formItems = [
      {
        name: 'current_password',
        rules: [
          {
            required: true,
            message: 'Please enter your current password',
          },
        ],
        icon: 'lock',
        label: 'Password',
        placeholder: 'Your current password',
        type: 'password',
      },
      {
        name: 'password',
        rules: passwordRules,
        icon: 'lock',
        label: 'New Password',
        placeholder: 'Your new Password',
        type: 'password',
        validateFirst: true,
        decoratorOptions: {
          onChange: passwordOnChange,
        },
      },
      {
        name: 'password_confirmation',
        rules: passwordConfirmationRules,
        icon: 'lock',
        label: 'New Password Confirmation',
        placeholder: 'Confirm your new password',
        type: 'password',
        validateFirst: true,
      },
    ];
    return formItems.map((itemProps, index) => (
      <LoginFormItem
        {...itemProps}
        key={itemProps.name}
        getFieldDecorator={getFieldDecorator}
        autoFocus={index === 0 && true}
      />
    ));
  };

  render() {
    const session = Session.get();
    const {
      location: { state = {} },
    } = this.props;
    const isValid = state.username && session.client && Session.challenge();
    const { redirectTo } = this.state;

    if (!isValid) {
      return <Redirect to="/error" />;
    }

    if (redirectTo) {
      return <Redirect to={redirectTo} />;
    }

    return (
      <LoginCard title="Renew Your Password">
        <Form onSubmit={this.handleSubmit}>
          {this.renderFormItems()}
          <PasswordRequirements />
          <LoginSubmit loading={this.state.loading}>Reset Password</LoginSubmit>
        </Form>
      </LoginCard>
    );
  }
}

export default Form.create()(
  withFeatureFlag('ketKeet3316RiskPasswordRemediation', NewPassword, OldNewPassword),
);
